(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.ZugHatsPricing = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  function positiveInteger(value) {
    if (typeof value !== 'number') return NaN;
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : NaN;
  }

  function validateConfig(config) {
    if (!config || config.version !== 1 || config.currency !== 'USD' ||
        config.pricing_mode !== 'linear_interpolation') {
      throw new Error('Hats pricing metadata is invalid.');
    }

    var minimum = positiveInteger(config.minimum_quantity);
    var maximum = positiveInteger(config.maximum_quantity);
    var presets = config.preset_quantities;
    var anchors = config.anchors;

    if (!Number.isFinite(minimum) || !Number.isFinite(maximum) || minimum > maximum ||
        !Array.isArray(presets) || presets.length === 0 ||
        !Array.isArray(anchors) || anchors.length < 2) {
      throw new Error('Hats pricing quantity limits are invalid.');
    }

    var previousQuantity = 0;
    var previousPrice = Infinity;
    anchors.forEach(function (anchor) {
      var quantity = positiveInteger(anchor && anchor.quantity);
      var price = positiveInteger(anchor && anchor.unit_price_cents);
      if (!Number.isFinite(quantity) || !Number.isFinite(price) ||
          quantity <= previousQuantity || price > previousPrice) {
        throw new Error('Hats pricing anchors must increase in quantity and not increase in unit price.');
      }
      previousQuantity = quantity;
      previousPrice = price;
    });

    if (anchors[0].quantity !== minimum ||
        anchors[anchors.length - 1].quantity !== maximum) {
      throw new Error('Hats pricing limits must match the first and last anchors.');
    }

    var seenPresets = {};
    presets.forEach(function (preset) {
      var quantity = positiveInteger(preset);
      if (!Number.isFinite(quantity) || quantity < minimum || quantity > maximum ||
          seenPresets[quantity]) {
        throw new Error('Hats pricing presets are invalid.');
      }
      seenPresets[quantity] = true;
    });

    return true;
  }

  function unitPriceCents(config, quantity) {
    validateConfig(config);
    var requested = positiveInteger(quantity);
    if (!Number.isFinite(requested) ||
        requested < config.minimum_quantity ||
        requested > config.maximum_quantity) {
      throw new Error('Hats quantity is outside the approved range.');
    }

    var anchors = config.anchors;
    for (var index = 0; index < anchors.length; index += 1) {
      var upper = anchors[index];
      if (requested === upper.quantity) return upper.unit_price_cents;
      if (requested < upper.quantity) {
        var lower = anchors[index - 1];
        var ratio = (requested - lower.quantity) / (upper.quantity - lower.quantity);
        return Math.round(
          lower.unit_price_cents +
          ratio * (upper.unit_price_cents - lower.unit_price_cents)
        );
      }
    }

    throw new Error('Hats price could not be resolved.');
  }

  function calculate(config, quantity, turnaroundMultiplier) {
    var multiplier = Number(turnaroundMultiplier);
    if (!Number.isFinite(multiplier) || multiplier < 1) {
      throw new Error('Hats turnaround adjustment is invalid.');
    }

    var baseUnitPriceCents = unitPriceCents(config, quantity);
    var adjustedUnitPriceCents = Math.round(baseUnitPriceCents * multiplier);
    return {
      quantity: Number(quantity),
      baseUnitPriceCents: baseUnitPriceCents,
      unitPriceCents: adjustedUnitPriceCents,
      totalCents: adjustedUnitPriceCents * Number(quantity),
      turnaroundMultiplier: multiplier
    };
  }

  return {
    validateConfig: validateConfig,
    unitPriceCents: unitPriceCents,
    calculate: calculate
  };
});
